// Color Variables
// ================================================== //

export const ColorPalette = {
    $white: '#ffffff',
    $black: '#000000',

    $azure01: '#c8e9f4',
    $azure02: '#addbeb',
    $azure03: '#8dc9e6',
    $azure04: '#69b5dd',
    $azure05: '#54a1d3',
    $azure06: '#368ac0',
    $azure07: '#2578a9',
    $azure08: '#1d5f8a',
    $azure09: '#134d71',
    $azure10: '#133c59',

    $amber01: '#fbe9bf',
    $amber02: '#f8e09c',
    $amber03: '#f7d475',
    $amber04: '#f4c951',
    $amber05: '#f2bc41',
    $amber06: '#efa836',
    $amber07: '#ee9a36',
    $amber08: '#e4882b',
    $amber09: '#db7726',
    $amber10: '#d66221',

    $amethyst01: '#ede3fc',
    $amethyst02: '#daccec',
    $amethyst03: '#c7b4db',
    $amethyst04: '#b59eca',
    $amethyst05: '#a38db7',
    $amethyst06: '#9279a6',
    $amethyst07: '#806594',
    $amethyst08: '#6e5282',
    $amethyst09: '#5d3e70',
    $amethyst10: '#4b2a5e',

    $turquoise01: '#c0ede3',
    $turquoise02: '#a9e1d6',
    $turquoise03: '#8ed1c6',
    $turquoise04: '#7cc0b5',
    $turquoise05: '#69ada3',
    $turquoise06: '#579e95',
    $turquoise07: '#448d83',
    $turquoise08: '#317c73',
    $turquoise09: '#206b62',
    $turquoise10: '#0e5b52',

    $ruby01: '#f4bcbc',
    $ruby02: '#eb9d9d',
    $ruby03: '#de8181',
    $ruby04: '#d26d6d',
    $ruby05: '#c65f5f',
    $ruby06: '#b94e4a',
    $ruby07: '#ad4242',
    $ruby08: '#a13030',
    $ruby09: '#941e1e',
    $ruby10: '#880e0e',

    $emerald01: '#d5f6c0',
    $emerald02: '#c3e8ac',
    $emerald03: '#afdc91',
    $emerald04: '#9cce7c',
    $emerald05: '#89bf65',
    $emerald06: '#76b051',
    $emerald07: '#66a140',
    $emerald08: '#56932e',
    $emerald09: '#488421',
    $emerald10: '#397514',

    $graphite01: '#f0f0f0',
    $graphite02: '#d8d8d8',
    $graphite03: '#bdbdbd',
    $graphite04: '#999999',
    $graphite05: '#737373',
    $graphite06: '#5c5c5c',
    $graphite07: '#454545',
    $graphite08: '#383838',
    $graphite09: '#292929',
    $graphite10: '#1a1a1a',

    $slate01: '#dee1e8',
    $slate02: '#c8cbd4',
    $slate03: '#abaeb7',
    $slate04: '#888b94',
    $slate05: '#656871',
    $slate06: '#50535a',
    $slate07: '#414247',
    $slate08: '#313236',
    $slate09: '#212224',
    $slate10: '#1c1819',

    $alertRed: '#e84f4f',
    $alertOrange: '#ff9426',
    $alertYellow: '#ffd726',
    $alertGreen: '#80ce4d',
    $alertInfo: '#368ac0',
    $alertNeutral: '#dbdbdb',

    $alert01: '#e84f4f',
    $alert02: '#ff9426',
    $alert03: '#ffd726',
    $alert04: '#80ce4d'
};